import React from 'react';
import { Cell, List, ListDataRefresher } from 'ui-builder';
import TextField from '../../../shared/uibuilder/show/field/TextField';
import DocumentLabelsField from '../labels/DocumentLabelsField';
import { UpdateDocumentsTemplateButton } from './UpdateDocumentsTemplateForm';
import DeleteTemplateButton from './DeleteTemplateButton';
import CopyTemplateButton from './CopyTemplateButton';
import { DOCUMENTS_TEMPLATES_UPDATED, useDocumentsTemplatesService } from 'nekst-api';
import { GridLayout } from 'features/nekst-widgets';

export default function DocumentsTemplatesList() {
  const service = useDocumentsTemplatesService();
  return (
    <List
      getDataFunc={service.getDocumentsTemplates}
    >
      <GridLayout noDataMessage="No documents templates created">
        <TextField source="name" />
        <DocumentLabelsField source="_labels" label="Labels" />
        <Cell label="Actions">
          <UpdateDocumentsTemplateButton />
          <CopyTemplateButton />
          <DeleteTemplateButton />
        </Cell>
      </GridLayout>
      <ListDataRefresher eventName={DOCUMENTS_TEMPLATES_UPDATED} />
    </List>
  );
}
